export const blockIconsHardwareKeyboardDoubleArrowLeft = (
	<span className='material-symbols-outlined'>keyboard_double_arrow_left</span>
);
